import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupFetchInterceptor } from './api/axiosInterceptors';

// Install platform authentication before React mounts. Some route/provider
// effects issue API requests during the initial render; installing this in a
// component effect lets those requests bypass the signed init-data headers.
setupFetchInterceptor();

// Вызываем ready() как можно раньше — до рендера React-приложения.
// Telegram-клиент может закрыть мини-приложение по таймауту (~5 с),
// если не получит этот сигнал. Критично при запуске с иконки домашнего экрана.
if (window.Telegram?.WebApp?.ready) {
    window.Telegram.WebApp.ready();
}

// MAX ожидает тот же сигнал готовности до загрузки React-приложения.
// Вызов из MessengerProvider происходит слишком поздно при медленной загрузке bundle.
if (window.WebApp?.ready) {
    window.WebApp.ready();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Глобальный перехват beforeinstallprompt для Web PWA
if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        // Браузер по умолчанию не показывает системный баннер
        e.preventDefault();
        // Сохраняем событие глобально, чтобы использовать в хуках/компонентах
        window.__pwaDeferredPrompt = e;
        // Сообщаем слушателям, что появилось событие установки
        window.dispatchEvent(new CustomEvent('pwa-beforeinstallprompt'));
    });

    window.addEventListener('appinstalled', () => {
        // После установки больше не нужно показывать кнопку
        window.__pwaDeferredPrompt = null;
        window.dispatchEvent(new CustomEvent('pwa-appinstalled'));
    });
}

function isPushManagerActive(pushManager) {
    if (!pushManager) {
      console.warn('PushManager is not available');
      return false;
    }
    return true;
  }
  

if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        const swRegistration = await navigator.serviceWorker.register(
            '/service-worker.js',
            {
                scope: '/',
            },
        );

        console.log('swRegistration', swRegistration);

        const pushManager = swRegistration.pushManager;

        console.log('pushManager', pushManager);

        if (!isPushManagerActive(pushManager)) {
            return;
        }

        const permissionState = await pushManager.permissionState({ userVisibleOnly: true });

        console.log('permissionState', permissionState);
    });
}
